(function(window, mL, mL_errors, mL_events, mL_config) {
    "use strict";

    // ver 3 mlahart_tavano
    //sitekey 6Le1CVEfAAAAAHRfvx89Wqi6t8ZHwtpewuXw77g7 
    //secret 6Le1CVEfAAAAAPoGCx4vcLgnz7EY7KvEYZFoB9TU

    var key = 'recaptcha';
    var site_key = '6Ldy_2oeAAAAAPT6-zU2W-zcpyvOf9HSnbOir2qg';
    var api_key = 'AIzaSyAmPgBZ7oAUkOSrEYJ3DOg4E4kLd8ns-VQ';
    var assesment_url = 'https://recaptchaenterprise.googleapis.com/v1beta1/projects/mlahart-1151/assessments?key=' + api_key;

    function safe_start() {
        if (mL_config.do_not_track || !mL_config.tags || !mL_config.tags.recap) return;

        mL.recap = mL.recap || {};

        function update_score(action, do_not_update, callback) {

            grecaptcha.enterprise.execute(site_key, { action: action }).then(function(token) {

                if (do_not_update) return;

                var _req_body = { "event": { "token": token, "siteKey": site_key, "expectedAction": action } };

                mL_config.post_json_req(assesment_url, JSON.stringify(_req_body), function(res_data) {
                    // do something with the score

                    if (!res_data || !res_data.score) throw new Error('grecaptcha did not return a score');

                    mL.recap.score = res_data.score;
                    mL.recap.data = res_data;


                    if (typeof callback === 'function') {
                        callback(res_data.score > 0.2, res_data);
                    }

                    //console.log('res_data', res_data);

                });
            });
        }

        /*

        mL.recap.update('test_action', false, function(proceed, data){
            console.log(res);
        });
        
        try{
            if(typeof mL !== 'undefined' && mL.recap &&  mL.recap.update){ mL.recap.update('action'); } 
        } catch(err){
            console.error(err);    
        }        
        */


        function add_listeners() {
            mL_events.subscribe('cart.remove_item', function(msg, data) {
                mL.recap.update('remove_item', true);
            });
            mL_events.subscribe('cart.add_item', function(msg, data) {
                mL.recap.update('add_item', true);
            });
            mL_events.subscribe('order.proceed_to_checkout', function(msg, data) {
                mL.recap.update('proceed_to_checkout', true);
            });

            mL_events.subscribe('order.pageview', function(msg, data) {
                var _url = data.url;
                if (_url.indexOf('confirmation') !== -1) return;

                if (_url.indexOf('login-register') !== -1) {
                    mL.recap.update('login_register');
                } else if (_url.indexOf('opc') !== -1) {
                    mL.recap.update('opc');
                } else if (_url.indexOf('review') !== -1) {
                   mL.recap.update('review');
                }
            });
        }

        mL.recap.init = function() {
            if (mL.recap.is_init) return false;

            mL.add_tracker('https://www.google.com/recaptcha/enterprise.js?render=' + site_key, 'recaptcha', false, function() {
                //console.log('loaded');
                grecaptcha.enterprise.ready(function() {
                    //update_score('page_view');
                    mL.recap.update = function(action, do_not_update, callback) {
                        try {
                            update_score(action, do_not_update, callback);
                        } catch (err) {
                            mL_errors(err);
                        }
                    };

                    add_listeners();

                    if(mL_config.is_checkout) {
                        mL.recap.update('checkout_init');
                    }
                });
            });

            mL.recap.is_init = true;

            if (mL_config.DEBUG) console.log(key + ' - plugin loaded');
        };

    }

    try {
        safe_start();
    } catch (err) {
        mL_errors(new Error('safe_start failed - ' + key.toUpperCase()));
        mL_errors(err);
    }


}(window, window.mL, window.mL_errors, window.mL_events, window.mL_config));